document.addEventListener('DOMContentLoaded', () => {
  const slider = document.getElementById('Slider-template--24837264638255__slider_LgMwMC');

  if (slider) {
    let startX = 0; // スワイプ/ドラッグ開始時のX座標
    let currentScrollLeft = 0; // スワイプ/ドラッグ開始時のスクロール位置
    let isDragging = false; // ドラッグ中かどうかのフラグ
    let dragMoveAmount = 0; // ドラッグ中の総移動量 (ピクセル単位)

    // スライドの幅を動的に取得
    const getSlideWidth = () => {
      const firstSlide = slider.querySelector('.slideshow__slide');
      // 幅が0の場合は、安全のために親要素の幅を返す
      return firstSlide ? firstSlide.offsetWidth : slider.offsetWidth;
    };

    // --- イベントリスナーの追加関数 ---
    // イベントハンドラの重複登録を防ぐために関数化
    const addSliderEventListeners = () => {
      // --- タッチイベント (スマホ用) ---
      slider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].pageX;
        currentScrollLeft = slider.scrollLeft;
        isDragging = true;
        dragMoveAmount = 0; // リセット
        slider.style.scrollBehavior = 'auto'; // スムーズスクロールを一時的に無効化
      }, { passive: false }); // preventDefaultを使用する可能性があるのでpassive: false

      slider.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        // スワイプ中にブラウザのデフォルトスクロールを防止
        e.preventDefault(); 
        // touchmove中も移動量を更新（見た目の追従には必要だが、最終的な位置はtouchendで制御）
        dragMoveAmount = e.touches[0].pageX - startX;
        // slider.scrollLeft = currentScrollLeft - dragMoveAmount; // これを入れると指に追従する

      }, { passive: false }); // preventDefaultを使用するのでpassive: false

      slider.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        handleSwipeEnd(); // 共通の処理を呼び出す
      });

      // --- マウスイベント (PC用) ---
      slider.addEventListener('mousedown', (e) => {
        // マウスの左ボタンのみを対象
        if (e.button !== 0) return; 
        startX = e.pageX;
        currentScrollLeft = slider.scrollLeft;
        isDragging = true;
        dragMoveAmount = 0; // リセット
        slider.style.cursor = 'grabbing'; // カーソルを変更してドラッグ中を視覚的に示す
        slider.style.userSelect = 'none'; // テキスト選択を防ぐ
        slider.style.scrollBehavior = 'auto'; // スムーズスクロールを一時的に無効化
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        // マウスのドラッグ中にブラウザのデフォルトスクロールを防止
        e.preventDefault(); 
        // mousemove中も移動量を更新
        dragMoveAmount = e.pageX - startX;
        // slider.scrollLeft = currentScrollLeft - dragMoveAmount; // これを入れると指に追従する
      });

      slider.addEventListener('mouseup', () => {
        if (!isDragging) return;
        isDragging = false;
        slider.style.cursor = 'grab'; // カーソルを元に戻す
        slider.style.userSelect = 'auto'; // テキスト選択を有効に戻す
        handleSwipeEnd(); // 共通の処理を呼び出す
      });

      // マウスがスライダー領域から離れてもドラッグを終了させる
      slider.addEventListener('mouseleave', () => {
        if (isDragging) {
          isDragging = false;
          slider.style.cursor = 'grab';
          slider.style.userSelect = 'auto';
          handleSwipeEnd(); // 中途半端なスワイプも処理する
        }
      });
    };

    // --- スワイプ終了時の共通処理 ---
    function handleSwipeEnd() {
      const slideWidth = getSlideWidth();
      // スワイプのしきい値 (スライド幅の10%)
      const threshold = slideWidth * 0.1; 
      
      // 現在のスライド位置から、最も近いスライドのインデックスを計算
      // dragMoveAmount が負のときは右にスワイプ（スライドインデックスを減らす方向）
      // dragMoveAmount が正のときは左にスワイプ（スライドインデックスを増やす方向）
      let targetSlideIndex = Math.round((currentScrollLeft - dragMoveAmount) / slideWidth);

      // 強くスワイプした場合でも、1枚だけ移動するように調整
      if (Math.abs(dragMoveAmount) > threshold) {
        if (dragMoveAmount < 0) { // 左にスワイプ（次へ）
            targetSlideIndex = Math.floor(currentScrollLeft / slideWidth) + 1;
        } else { // 右にスワイプ（前へ）
            targetSlideIndex = Math.ceil(currentScrollLeft / slideWidth) - 1;
        }
      } else {
        // しきい値に満たない場合は、最も近いスライドにスナップ（元の位置に戻る可能性も含む）
        targetSlideIndex = Math.round(currentScrollLeft / slideWidth);
      }


      // インデックスが範囲内に収まるように調整
      const totalSlides = slider.querySelectorAll('.slideshow__slide').length;
      targetSlideIndex = Math.max(0, Math.min(targetSlideIndex, totalSlides - 1));

      // 目標スクロール位置をスライド幅の正確な倍数に設定
      const targetScrollPosition = targetSlideIndex * slideWidth;

      slider.scrollTo({
        left: targetScrollPosition,
        behavior: 'smooth' // スムーズなアニメーションを有効にする
      });

      // スムーズスクロールを有効に戻す
      requestAnimationFrame(() => {
        slider.style.scrollBehavior = 'smooth';
      });
    }

    // スライダーのサイズ変更時（例: ウィンドウのリサイズ）にスライド位置を再調整
    window.addEventListener('resize', () => {
        const slideWidth = getSlideWidth();
        if (slideWidth > 0) {
            const currentSlideIndex = Math.round(slider.scrollLeft / slideWidth);
            slider.scrollTo({
                left: currentSlideIndex * slideWidth,
                behavior: 'smooth'
            });
        }
    });

    // 初期イベントリスナーの追加
    addSliderEventListeners();
  }
});